import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Phone, Mail, CheckCircle2, Info, ArrowRight, Calendar, Calculator, Sparkles } from 'lucide-react'
import Lightbox from '../components/Lightbox'

const FALLBACK_MASKINER = [
  {
    id: "6cd018e2-313b-4da1-90a6-690fdc981671",
    title: { da: "Caterpillar 301.8 Minigraver" },
    category: { da: "Minigravere" },
    price: { da: "Fra 1.200 kr./dag ekskl. moms" },
    images: [
      "https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/be81d1e6-fc9f-4ee9-86fc-8ad27ff0c3f3.jpg",
      "https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/5a3bc5c4-2eed-4494-ab16-658265975eb5.jpg"
    ],
    slug: { da: "caterpillar-301-8-minigraver" },
    description: { da: "<p>Vores Caterpillar 301.8 minigraver is den perfekte maskine til mindre og mellemstore graveopgaver. Den is kompakt, utrolig stærk og nem at manøvrere, hvilket gør den ideel til havearbejde, udgravning til indkørsler, drænarbejde og fundamenter.</p><p>Maskinen leveres på en solid trailer, så du nemt selv kan transportere den, eller vi kan levere den direkte til din adresse i Skibby og omegn.</p>" },
    specifications: { da: "<ul><li><strong>Vægt:</strong> 2.018 kg</li><li><strong>Bredde:</strong> 990 mm (justerbar undervogn op til 1300 mm)</li><li><strong>Gravedybde:</strong> Op til 2.570 mm</li><li><strong>Drivmiddel:</strong> Diesel</li><li><strong>Udstyr:</strong> Leveres med standard graveskovl og planerskovl</li></ul>" }
  },
  {
    id: "66ddd5cd-d74e-4561-b48e-01517875add1",
    title: { da: "Husqvarna Pladevibrator & Jordloppe" },
    category: { da: "Komprimeringsmateriel" },
    price: { da: "Fra 250 kr./dag ekskl. moms" },
    images: [
      "https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/a7427b13-3098-4c44-892e-8dfc3c9780ba.jpg",
      "https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/cd9984a7-36d5-46c9-a1d6-105d875d9689.jpg"
    ],
    slug: { da: "husqvarna-pladevibrator-jordloppe" },
    description: { da: "<p>Effektive maskiner til komprimering af sand, grus og jord. Perfekt til forberedelse af flisebelægning, indkørsler, terrasser eller komprimering i render.</p><p>Vi tilbyder både robuste pladevibratorer og kompakte jordlopper (stampere), der sikrer et stabilt og holdbart underlag til dit projekt.</p>" },
    specifications: { da: "<ul><li><strong>Pladevibrator vægt:</strong> 90 kg</li><li><strong>Jordloppe vægt:</strong> 68 kg</li><li><strong>Drivmiddel:</strong> Benzin (4-takt)</li><li><strong>Anvendelse:</strong> Ideel til sand, grus, stabilgrus og jord</li></ul>" }
  },
  {
    id: "99859861-a348-43a2-86bf-1d4046731c74",
    title: { da: "SoRoTo 120L Tvangsblander" },
    category: { da: "Blandemaskiner" },
    price: { da: "Fra 300 kr./dag ekskl. moms" },
    images: [
      "https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/a4dfb078-af8c-4ef7-9de8-217f19db1774.jpg",
      "https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/3bb9d101-7f42-4642-b64f-65406cd85b9f.jpg"
    ],
    slug: { da: "soroto-120l-tvangsblander" },
    description: { da: "<p>Den originale SoRoTo 120L tvangsblander er murerens foretrukne valg. Den blander hurtigt og effektivt alt fra beton og mørtel til puds og epoxy.</p><p>Takket være det smarte design og de robuste hjul er den nem at transportere rundt på byggepladsen og kan nemt gå igennem almindelige døråbninger.</p>" },
    specifications: { da: "<ul><li><strong>Blandekapacitet:</strong> 120 liter</li><li><strong>Motor:</strong> 230V / 1.1 kW</li><li><strong>Vægt:</strong> 90 kg</li><li><strong>Bredde:</strong> 72 cm</li><li><strong>Anvendelse:</strong> Beton, mørtel, puds, tørbeton og fliseklæb</li></ul>" }
  }
]

const LOGO_URL = "https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/6fc95741-bbf3-49e6-9c69-766b0204a25f.png"

export default function Udlejning() {
  const [maskiner, setMaskiner] = useState([])
  const [loading, setLoading] = useState(true)
  const [lightboxImages, setLightboxImages] = useState([])
  const [lightboxIndex, setLightboxIndex] = useState(null)

  // Booking form states
  const [selectedItem, setSelectedItem] = useState('')
  const [duration, setDuration] = useState('1_dag')
  const [calculatedPrice, setCalculatedPrice] = useState({ ex: 0, inc: 0, text: '' })
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    startDate: '',
    message: '',
    website_url: '' // Honeypot
  })
  const [submitting, setSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState({ success: null, message: '' })

  const openLightbox = (images, index) => {
    setLightboxImages(images)
    setLightboxIndex(index)
  }

  useEffect(() => {
    // Sæt meta-data
    document.title = "Udlejning af entreprenørmaskiner | D&W Udlejning ApS"
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Se vores udvalg af mindre entreprenørmaskiner til udlejning i Skibby. Vi udlejer minigravere, pladevibratorer, tvangsblandere og affugtere.')
    }

    fetch('https://api.dev.auxo.dk/public/content/maskiner')
      .then((res) => {
        if (!res.ok) throw new Error('Kunne ikke hente maskiner')
        return res.json()
      })
      .then((data) => {
        if (data && data.length > 0) {
          setMaskiner(data)
        } else {
          setMaskiner(FALLBACK_MASKINER)
        }
        setLoading(false)
      })
      .catch((err) => {
        console.error('Fejl ved hentning af maskiner:', err)
        setMaskiner(FALLBACK_MASKINER)
        setLoading(false)
      })
  }, [])

  // Prisberegning
  useEffect(() => {
    if (!selectedItem) {
      setCalculatedPrice({ ex: 0, inc: 0, text: 'Vælg en maskine for at se pris' })
      return
    }

    const item = maskiner.find(m => m.id === selectedItem)
    if (!item) return

    // Find basepris (f.eks. "Fra 1.200 kr./dag" -> 1200)
    const priceText = item.price?.da || ''
    const match = priceText.match(/(\d[\d\s.]*)/)
    const basePrice = match ? parseInt(match[0].replace(/[.\s]/g, ''), 10) : 1000

    let factor = 1
    let label = ''

    switch (duration) {
      case '1_dag':
        factor = 1
        label = '1 dag'
        break
      case '2_dage':
        factor = 1.8 // 10% rabat på dag 2
        label = '2 dage (inkl. 10% rabat)'
        break
      case 'weekend':
        factor = 1.5 // Weekendpris (fredag til mandag)
        label = 'Weekend (fredag til mandag)'
        break
      case '1_uge':
        factor = 4 // 1 uges leje (betal for 4 dage)
        label = '1 uge (7 dage - betal for 4)'
        break
      case 'andet':
        setCalculatedPrice({ ex: 0, inc: 0, text: 'Kontakt os for et skræddersyet tilbud' })
        return
      default:
        factor = 1
    }

    const exVat = Math.round(basePrice * factor)
    const incVat = Math.round(exVat * 1.25)

    setCalculatedPrice({
      ex: exVat,
      inc: incVat,
      text: `${exVat.toLocaleString('da-DK')} kr. ekskl. moms (${incVat.toLocaleString('da-DK')} kr. inkl. moms) for ${label}`
    })
  }, [selectedItem, duration, maskiner])

  // Håndter hash-scroll, hvis brugeren kommer fra forsiden og klikker på en specifik maskine
  useEffect(() => {
    if (!loading && window.location.hash) {
      const id = window.location.hash.substring(1)
      const element = document.getElementById(id)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100)
      }
    }
  }, [loading])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    setSubmitStatus({ success: null, message: '' })

    const selectedMachine = maskiner.find(m => m.id === selectedItem)
    const machineTitle = selectedMachine ? selectedMachine.title?.da : 'Ukendt maskine'

    const payload = {
      ...formData,
      form_type: 'Maskinleje Forespørgsel',
      valgt_maskine: machineTitle,
      lejeperiode: duration,
      beregnet_pris: calculatedPrice.ex > 0 ? calculatedPrice.text : 'Kontakt for pris'
    }

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })

      if (response.ok) {
        setSubmitStatus({
          success: true,
          message: 'Tak for din forespørgsel! Vi vender tilbage til dig hurtigst muligt med en bekræftelse.'
        })
        setFormData({
          name: '',
          company: '',
          email: '',
          phone: '',
          startDate: '',
          message: '',
          website_url: ''
        })
        setSelectedItem('')
      } else {
        throw new Error('Fejl ved indsendelse')
      }
    } catch (err) {
      setSubmitStatus({
        success: false,
        message: 'Der skete en fejl under afsendelsen. Prøv venligst igen eller ring til os direkte på 20 82 89 70.'
      })
    } finally {
      setSubmitting(false)
    }
  }

  const scrollToBooking = (machineId) => {
    setSelectedItem(machineId)
    const element = document.getElementById('booking-form-section')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <div className="bg-neutral-50 text-neutral-900 min-h-screen selection:bg-amber-500 selection:text-neutral-950">
      {/* INTRODUKTION SEKTION */}
      <section className="relative py-24 bg-white border-b border-neutral-200 overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#f3f4f6_1px,transparent_1px),linear-gradient(to_bottom,#f3f4f6_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none opacity-60" />
        <div className="absolute right-[-5%] top-[-5%] w-[400px] h-[400px] pointer-events-none opacity-[0.03] select-none">
          <img src={LOGO_URL} alt="D&W Logo Vandmærke" className="w-full h-full object-contain" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <span className="inline-block text-xs font-bold text-amber-600 uppercase tracking-widest bg-amber-50 px-3 py-1 rounded-md border border-amber-200">
            Maskinoversigt
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-5xl font-black tracking-tight text-neutral-900">
            Udlejning af <span className="text-amber-600">entreprenørmaskiner</span>
          </h1>
          <p className="text-neutral-600 text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed">
            Vi tilbyder et stærkt og driftssikkert udvalg af mindre entreprenørmaskiner til både private og erhverv. Vores fokus er på høj fleksibilitet, personlig service og maskiner, der altid er klar til brug.
          </p>
          <div className="pt-4 flex flex-wrap items-center justify-center gap-6 text-sm font-bold text-neutral-700">
            <span className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-amber-500" />
              Dags- og ugeleje
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-amber-500" />
              Rengjorte & klargjorte maskiner
            </span>
            <span className="flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5 text-amber-500" />
              Mulighed for levering
            </span>
          </div>
        </div>
      </section>

      {/* MASKINLISTE */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#e5e7eb_1px,transparent_1px),linear-gradient(to_bottom,#e5e7eb_1px,transparent_1px)] bg-[size:3rem_3rem] pointer-events-none opacity-40" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500" />
            </div>
          ) : (
            <div className="space-y-24">
              {maskiner.map((maskine) => (
                <div
                  key={maskine.id}
                  id={maskine.slug?.da}
                  className="scroll-mt-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start border-b border-neutral-200 pb-20 last:border-0 last:pb-0"
                >
                  {/* Venstre side: Billedgalleri for maskinen */}
                  <div className="lg:col-span-6 space-y-4">
                    <button
                      onClick={() => openLightbox(maskine.images || [], 0)}
                      className="relative rounded-xl overflow-hidden border border-neutral-200 bg-white aspect-[4/3] shadow-sm w-full text-left focus:outline-none cursor-zoom-in group"
                      aria-label={`Forstør billede af ${maskine.title?.da}`}
                    >
                      <img
                        src={maskine.images?.[0]}
                        alt={maskine.title?.da}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                      <span className="absolute top-4 left-4 bg-white/95 border border-neutral-200 text-amber-600 text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-md shadow-sm">
                        {maskine.category?.da}
                      </span>
                      <div className="absolute inset-0 bg-neutral-900/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                        <span className="px-4 py-2 rounded-md bg-white/95 border border-neutral-200 text-xs font-bold text-amber-600 uppercase tracking-wider shadow-sm">
                          Forstør billede
                        </span>
                      </div>
                    </button>

                    {/* Flere billeder, hvis tilgængelige */}
                    {maskine.images && maskine.images.length > 1 && (
                      <div className="grid grid-cols-3 gap-4">
                        {maskine.images.map((imgUrl, imgIndex) => (
                          <button
                            key={imgIndex}
                            onClick={() => openLightbox(maskine.images, imgIndex)}
                            className="relative rounded-lg overflow-hidden border border-neutral-200 bg-white aspect-[4/3] shadow-sm w-full text-left focus:outline-none cursor-zoom-in group"
                            aria-label={`Forstør detaljebillede ${imgIndex + 1} af ${maskine.title?.da}`}
                          >
                            <img
                              src={imgUrl}
                              alt={`${maskine.title?.da} detalje ${imgIndex + 1}`}
                              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-neutral-900/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                              <span className="px-2 py-1 rounded bg-white/95 border border-neutral-200 text-[10px] font-bold text-amber-600 uppercase tracking-wider shadow-sm">
                                Forstør
                              </span>
                            </div>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Højre side: Detaljer, beskrivelse og specifikationer */}
                  <div className="lg:col-span-6 space-y-6">
                    <div>
                      <h2 className="text-2xl sm:text-3xl font-black text-neutral-900 tracking-tight">
                        {maskine.title?.da}
                      </h2>
                      <div className="mt-2 flex items-baseline gap-2">
                        <span className="text-xs font-bold text-neutral-400 uppercase tracking-widest">Pris:</span>
                        <span className="text-xl font-black text-amber-600">{maskine.price?.da}</span>
                      </div>
                    </div>

                    {/* Beskrivelse (RICHTEXT_LEXICAL) */}
                    <div
                      className="prose prose-neutral max-w-none text-neutral-600 text-sm sm:text-base leading-relaxed space-y-4 [&_p]:leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: maskine.description?.da || '' }}
                    />

                    {/* Specifikationer (RICHTEXT_LEXICAL) */}
                    {maskine.specifications?.da && (
                      <div className="bg-white border border-neutral-200 p-5 rounded-xl space-y-3 shadow-sm">
                        <h3 className="text-sm font-bold text-neutral-800 uppercase tracking-wider flex items-center gap-2">
                          <Info className="w-4 h-4 text-amber-500" />
                          Tekniske specifikationer
                        </h3>
                        <div
                          className="prose prose-neutral max-w-none text-neutral-500 text-xs sm:text-sm space-y-2 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mt-1 [&_strong]:text-neutral-700"
                          dangerouslySetInnerHTML={{ __html: maskine.specifications?.da }}
                        />
                      </div>
                    )}

                    {/* Book maskine CTA */}
                    <div className="pt-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
                      <button
                        onClick={() => scrollToBooking(maskine.id)}
                        className="inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-md bg-amber-500 hover:bg-amber-400 text-neutral-950 font-bold text-sm transition-all duration-200 shadow-md shadow-amber-500/10 cursor-pointer"
                      >
                        <Calendar className="w-4 h-4 shrink-0" />
                        <span>Send forespørgsel</span>
                      </button>
                      <a
                        href="tel:20828970"
                        className="inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-md bg-neutral-900 hover:bg-neutral-800 text-white font-bold text-sm transition-all duration-200"
                      >
                        <Phone className="w-4 h-4 shrink-0" />
                        <span>Ring og book: 20 82 89 70</span>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* INTERAKTIV BOOKING SEKTION */}
      <section id="booking-form-section" className="relative py-24 bg-white border-t border-b border-neutral-200 overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#f3f4f6_1px,transparent_1px),linear-gradient(to_bottom,#f3f4f6_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none opacity-60" />

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-4 mb-12">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold text-amber-600 uppercase tracking-widest bg-amber-50 px-3 py-1 rounded-md border border-amber-200">
              <Calculator className="w-3.5 h-3.5" />
              Prisberegner & forespørgsel
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-neutral-900 tracking-tight">
              Send en uforpligtende <span className="text-amber-600">bookingforespørgsel</span>
            </h2>
            <p className="text-neutral-600 text-sm sm:text-base max-w-2xl mx-auto">
              Vælg den ønskede maskine og lejeperiode nedenfor for at se den forventede pris med det samme. Udfyld derefter dine oplysninger, så vender vi hurtigt tilbage med en bekræftelse.
            </p>
          </div>

          <div className="bg-neutral-50 border border-neutral-200 rounded-2xl p-6 sm:p-10 shadow-sm">
            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Spam-beskyttelse (Honeypot) - Skjult for mennesker */}
              <div className="sr-only absolute -top-[9999px] -left-[9999px]" aria-hidden="true">
                <label htmlFor="website_url">Efterlad dette felt tomt</label>
                <input
                  type="text"
                  id="website_url"
                  name="website_url"
                  value={formData.website_url}
                  onChange={handleInputChange}
                  tabIndex="-1"
                  placeholder="http://"
                />
              </div>

              {/* TRIN 1: VÆLG MASKINE & PERIODE */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label htmlFor="selectedItem" className="block text-sm font-bold text-neutral-800 uppercase tracking-wider">
                    1. Vælg maskine *
                  </label>
                  <select
                    id="selectedItem"
                    name="selectedItem"
                    required
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 font-medium focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                  >
                    <option value="">-- Vælg maskine --</option>
                    {maskiner.map(m => (
                      <option key={m.id} value={m.id}>
                        {m.title?.da} ({m.price?.da})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="space-y-2">
                  <label htmlFor="duration" className="block text-sm font-bold text-neutral-800 uppercase tracking-wider">
                    2. Vælg lejeperiode *
                  </label>
                  <select
                    id="duration"
                    name="duration"
                    required
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 font-medium focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                  >
                    <option value="1_dag">1 dag</option>
                    <option value="2_dage">2 dage (10% rabat)</option>
                    <option value="weekend">Weekend (fredag til mandag)</option>
                    <option value="1_uge">1 uge (7 dage - betal for 4)</option>
                    <option value="andet">Andet (skriv i bemærkninger)</option>
                  </select>
                </div>
              </div>

              {/* PRISVISNING */}
              <div className="bg-amber-50/80 border border-amber-200 rounded-xl p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div className="space-y-1">
                  <span className="text-xs font-bold text-amber-700 uppercase tracking-widest flex items-center gap-1">
                    <Sparkles className="w-3.5 h-3.5" />
                    Beregnet pris
                  </span>
                  <p className="text-neutral-900 font-bold text-sm sm:text-base">
                    {calculatedPrice.text}
                  </p>
                </div>
                {calculatedPrice.ex > 0 && (
                  <div className="text-right shrink-0">
                    <span className="block text-2xl font-black text-amber-600">
                      {calculatedPrice.ex.toLocaleString('da-DK')} kr.
                    </span>
                    <span className="text-[10px] font-bold text-neutral-400 uppercase tracking-wider">
                      Ekskl. moms / {calculatedPrice.inc.toLocaleString('da-DK')} kr. inkl. moms
                    </span>
                  </div>
                )}
              </div>

              {/* TRIN 2: KONTAKTOPLYSNINGER */}
              <div className="space-y-4 pt-4 border-t border-neutral-200">
                <h3 className="text-sm font-bold text-neutral-800 uppercase tracking-wider">
                  3. Dine oplysninger
                </h3>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="space-y-2">
                    <label htmlFor="name" className="block text-xs font-bold text-neutral-600 uppercase tracking-wider">
                      Dit navn *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                      placeholder="F.eks. Anders Andersen"
                    />
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="company" className="block text-xs font-bold text-neutral-600 uppercase tracking-wider">
                      Firma (valgfrit)
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                      placeholder="F.eks. Entreprenør ApS"
                    />
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="email" className="block text-xs font-bold text-neutral-600 uppercase tracking-wider">
                      E-mailadresse *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                      placeholder="F.eks. anders@mail.dk"
                    />
                  </div>

                  <div className="space-y-2">
                    <label htmlFor="phone" className="block text-xs font-bold text-neutral-600 uppercase tracking-wider">
                      Telefonnummer *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                      placeholder="F.eks. 12 34 56 78"
                    />
                  </div>

                  <div className="space-y-2 sm:col-span-2">
                    <label htmlFor="startDate" className="block text-xs font-bold text-neutral-600 uppercase tracking-wider">
                      Ønsket startdato *
                    </label>
                    <input
                      type="date"
                      id="startDate"
                      name="startDate"
                      required
                      value={formData.startDate}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200"
                    />
                  </div>

                  <div className="space-y-2 sm:col-span-2">
                    <label htmlFor="message" className="block text-xs font-bold text-neutral-600 uppercase tracking-wider">
                      Bemærkninger eller særlige ønsker (valgfrit)
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows="4"
                      value={formData.message}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 rounded-lg border border-neutral-300 bg-white text-neutral-900 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200 resize-none"
                      placeholder="Skriv f.eks. hvis du ønsker levering, eller har spørgsmål til maskinen..."
                    />
                  </div>
                </div>
              </div>

              {/* FEJL / SUCCES MEDDELELSER */}
              {submitStatus.success !== null && (
                <div className={`p-4 rounded-lg border text-sm font-medium ${
                  submitStatus.success 
                    ? 'bg-green-50 border-green-200 text-green-800' 
                    : 'bg-red-50 border-red-200 text-red-800'
                }`}>
                  {submitStatus.message}
                </div>
              )}

              {/* INDSEND KNAP */}
              <div className="pt-2">
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg bg-amber-500 hover:bg-amber-400 disabled:bg-amber-300 text-neutral-950 font-bold text-base transition-all duration-200 shadow-lg shadow-amber-500/10 cursor-pointer"
                >
                  {submitting ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-neutral-950" />
                      <span>Sender forespørgsel...</span>
                    </>
                  ) : (
                    <>
                      <Calendar className="w-5 h-5" />
                      <span>Send bookingforespørgsel</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* FLEKSIBEL UDLEJNING INFO-SEKTION */}
      <section className="relative py-24 bg-white border-t border-neutral-200 overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#f3f4f6_1px,transparent_1px),linear-gradient(to_bottom,#f3f4f6_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none opacity-60" />
        <div className="absolute left-[-5%] bottom-[-5%] w-[400px] h-[400px] pointer-events-none opacity-[0.03] select-none">
          <img src={LOGO_URL} alt="D&W Logo Vandmærke" className="w-full h-full object-contain" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-neutral-50 border border-neutral-200 rounded-2xl p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center shadow-sm">
            <div className="lg:col-span-8 space-y-4">
              <h3 className="text-2xl font-black text-neutral-900 tracking-tight">
                Fleksible lejeaftaler tilpasset dit projekt
              </h3>
              <p className="text-neutral-600 text-sm sm:text-base leading-relaxed">
                Vi ved, at projekter kan trække ud, eller at vejret kan drille. Derfor tilbyder vi yderst fleksible lejeaftaler. Har du brug for at forlænge lejeperioden, eller ønsker du levering og afhentning direkte på din adresse i Skibby og omegn? Ring til os, så finder vi en løsning, der passer dig.
              </p>
            </div>
            <div className="lg:col-span-4 flex justify-end">
              <a
                href="tel:20828970"
                className="w-full lg:w-auto inline-flex items-center justify-center gap-2 px-6 py-4 rounded-md bg-amber-500 hover:bg-amber-400 text-neutral-950 font-bold text-sm transition-colors duration-200 whitespace-nowrap shadow-md shadow-amber-500/10"
              >
                <span>Ring og hør nærmere</span>
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox til stor visning */}
      {lightboxIndex !== null && lightboxImages.length > 0 && (
        <Lightbox
          images={lightboxImages}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onNext={() => setLightboxIndex((prev) => (prev + 1) % lightboxImages.length)}
          onPrev={() => setLightboxIndex((prev) => (prev - 1 + lightboxImages.length) % lightboxImages.length)}
        />
      )}
    </div>
  )
}
